import SaberLight from './SaberLight';

export default {
  saberLight: SaberLight,
};
